let supabaseClientPromise;

const getSupabaseClient = async () => {
  supabaseClientPromise ||= import("../config/supabase").then(
    ({ supabase }) => supabase,
  );

  try {
    return await supabaseClientPromise;
  } catch (error) {
    supabaseClientPromise = undefined;
    throw new Error("Unable to load the Supabase client.", { cause: error });
  }
};

const invokeReferralFunction = async (action, values = {}) => {
  const supabase = await getSupabaseClient();
  if (!supabase) {
    throw new Error(
      "Supabase is not configured. Add VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY.",
    );
  }

  let data, error;
  try {
    ({ data, error } = await supabase.functions.invoke("referrals", {
      body: { action, ...values },
    }));
  } catch (invokeError) {
    throw new Error(
      invokeError?.message || "Referral service request failed.",
      { cause: invokeError },
    );
  }

  if (error) {
    let message = error.message || "Referral service request failed.";
    if (error.context instanceof Response) {
      const payload = await error.context.clone().json().catch(() => null);
      if (payload?.message) message = payload.message;
    }
    throw new Error(message);
  }

  if (!data?.success) {
    throw new Error(data?.message || "Referral service request failed.");
  }

  return data.data;
};

export const connectReferralWallet = (walletAddress) =>
  invokeReferralFunction("connect_wallet", { walletAddress });

export const getReferralProfile = (walletAddress) =>
  invokeReferralFunction("get_profile", { walletAddress });

export const syncReferralPurchase = (transactionHash) =>
  invokeReferralFunction("sync_purchase", { transactionHash });
